// src/components/ResourceCard.js (Updated with correct CSS class names)

import React from 'react';

// --- 1. Import GIF Assets ---
// NOTE: You must adjust these paths to where your actual GIF files are located.
import VideoGif from '../assets/icons/video.gif';
import WebsiteGif from '../assets/icons/website.gif';
import ArticleGif from '../assets/icons/article.gif';
import CourseGif from '../assets/icons/course.gif';

const ResourceCard = ({ title, description, type, url, duration }) => {
  // Simple logic to set icon/color based on resource type
  // Fallback: If 'type' is not found, we use a gray background and a simple question mark emoji for clarity.
  const typeInfo = {
    'video': { icon: VideoGif, color: 'var(--color-status-red)' },
    'website': { icon: WebsiteGif, color: 'var(--color-status-blue)' },
    'article': { icon: ArticleGif, color: 'var(--color-status-green)' },
    'course': { icon: CourseGif, color: 'var(--color-accent-teal)' },
  }[type] || { icon: '❓', color: 'gray', isEmoji: true }; // Simplified fallback

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className="resource-link">
      <div className="resource-card glossy-card">
        <div className="card-header">
          {/* Using the resource-type-icon class for the wrapper */}
          <span 
            className="resource-type-icon" 
            style={{ backgroundColor: typeInfo.color }}
          >
            {/* Conditional rendering: Render <img> for GIFs, <span> for emoji fallback */}
            {typeInfo.isEmoji ? (
                <span className="resource-type-emoji">{typeInfo.icon}</span>
            ) : (
                <img 
                  src={typeInfo.icon} 
                  alt={`${type} icon`} 
                  className="resource-type-icon-image"
                />
            )}
          </span>
          <span className="resource-type-label">{type.toUpperCase()}</span>
        </div>
        
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
        
        {duration && (
          <span className="resource-duration">
            🕒 Est. {duration}
          </span>
        )}
      </div>
    </a>
  );
};

export default ResourceCard;